import { render } from "./text.vue?vue&type=template&id=5d3467dc&scoped=true"
import script from "./text.vue?vue&type=script&lang=js"
export * from "./text.vue?vue&type=script&lang=js"

import "./text.vue?vue&type=style&index=0&id=5d3467dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3467dc"]])

export default __exports__